/**
 * 會員「預約紀錄」/「住宿記錄」詳情頁共用的 request loading 名稱（與結帳混用 preferHotel 區隔）
 */
export const MEMBER_ORDER_CONTAINER_DETAIL = 'fetchMemberOrderContainerDetail'
